import { render, staticRenderFns } from "./albumShow.vue?vue&type=template&id=16b64980&"
import script from "./albumShow.vue?vue&type=script&lang=js&"
export * from "./albumShow.vue?vue&type=script&lang=js&"
import style0 from "./albumShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports